import {connect} from 'react-redux';
import InspectedDatabasePage from './InspectedDatabasePage';
import {getListByShared} from '../../actions/getListByShared';
import {setPage} from '../../actions/setPage';

const mapStateToProps = ({
                           inspectedDatabase: {list, statistics, page, totalPages, totalResultCount}
                         }) => ({
  list, statistics, page, totalPages, totalResultCount
});

export default connect(
  mapStateToProps,
  {setPage, getListByShared}
)(InspectedDatabasePage);
